import _typeof from "@babel/runtime/helpers/typeof";
import { TRACK_TYPE } from '../../constants/AdobeAnalyticConstants';
import { sendNewRelicMessage } from '../../utils/NewRelicUtils';
/**
 * Predicate to check if satellite is availble in the window object
 */
export var isSatelliteAvailable = function isSatelliteAvailable() {
  return typeof window !== 'undefined' && '_satellite' in window && window._satellite !== null && _typeof(window._satellite) === 'object' && 'track' in window._satellite && typeof window._satellite.track === 'function';
};

/**
 * Adds transaction object to window.digitalData Object.
 * Case when host doesn't have adobe loaded, callback will be called immediately
 * Case when host has adobe, callback will be registered with Adobe modules and will be called upon successful logging of purchase event
 * Case when host has adobe and Adobe modules takes too long to call the callback, invoke callback anyways
 * Documentation: https://confluence.cheggnet.com/display/MT/Purchase+Event
 *
 *
 * @param transaction
 */
export var trackOrderConfirmationPixel = function trackOrderConfirmationPixel(_ref) {
  var payload = _ref.payload,
    dispatch = _ref.dispatch,
    resolve = _ref.resolve,
    blockDDRW = _ref.blockDDRW;
  if (!window.digitalData) window.digitalData = {};
  var adobeData = payload.adobeData,
    callbackData = payload.callbackData,
    callback = payload.callback;
  window.digitalData.transaction = adobeData.transaction;
  window.digitalData.cart = adobeData.cart;
  if (blockDDRW) window.digitalData.blockDDRW = true;
  if (isSatelliteAvailable()) {
    var startTime = Date.now();
    var adobeCallback = function adobeCallback() {
      callback(dispatch, callbackData);
      clearTimeout(timeoutFnHandler);
      resolve();
    };
    var adobeTimeoutFn = function adobeTimeoutFn() {
      var endTime = Date.now();
      sendNewRelicMessage("Timed out waiting for Adobe Confirmation Pixel callback. Time passed: ".concat((endTime - startTime) / 1000));
      callback(dispatch, callbackData);
      resolve();
    };
    var timeoutFnHandler = function (fn) {
      return setTimeout(fn, 5000);
    }(adobeTimeoutFn);
    window._satellite.track(TRACK_TYPE.PURCHASE);
    window.cheggAnalyticsUtils.registerCallback(adobeCallback);
  } else {
    callback(dispatch, callbackData);
    resolve();
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/redux/adobeAnalytic/adobeAnalytic.utils.js
// module id = 4700
// module chunks = 11